import Styles from "./SelfListing.module.css";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import { ReactComponent as Chat } from "../../../../assets/images/Chat_white.svg";
import { ReactComponent as ChatInactive } from "../../../../assets/images/Chat_grey.svg";
import { ReactComponent as Download } from "../../../../assets/images/Download_white.svg";
import { ReactComponent as DownloadInactive } from "../../../../assets/images/download_gray.svg";
import { ReactComponent as Duplicate } from "../../../../assets/images/Duplicate_white.svg";
import { ReactComponent as DuplicateInactive } from "../../../../assets/images/duplicate_gray.svg";
import { ReactComponent as Edit } from "../../../../assets/images/Edit_white.svg";
import { ReactComponent as EditInactive } from "../../../../assets/images/edit_grey.svg";
import { ReactComponent as Request } from "../../../../assets/images/Request_white.svg";
import { ReactComponent as RequestInactive } from "../../../../assets/images/request_grey.svg";
import {
  fetchLedgerBids,
  setActiveListingId,
} from "../../../../Redux/Slices/CapacitySlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ConGenListingModal from "../../../Modals/ConGen/ConGenListingModal";
import { useState } from "react";
import {
  createListing,
  editListing,
  holdListing,
  resumeListing,
  withdrawListing,
} from "../../../../Services/BuySell/Creation";
import { getCommonChatDetails } from "../../../../Services/Chat/Chat";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import CombinedChatModal from "../../../ChatApplication/CombinedChatModal/CombinedChatModal";
import { usePdfPreview } from "../../../../hooks/usePdfPreview";
import { formatDate, formatSlotTime } from "../../../../helpers/dateFormat";
import React, { forwardRef } from "react";
import { downloadListing } from "../../../../Services/ApiCalling/Listing";
import { toast } from "react-toastify";

const SelfListingBox = forwardRef(
  (
    { data, alterButton, isActive, setActiveId, activeId, handleOpenIndent },
    ref,
  ) => {
    const user = useSelector(
      (state) => state?.persistedReducer?.userType,
    ).toLowerCase();
    const dispatch = useDispatch();

    const trader = useSelector((state) => state?.persistedReducer);

    const traderParent = trader?.roles?.includes("TRADER");
    const userId = trader?.user?.user?.userId;

    const viewButtons = traderParent
      ? userId === data?.traderAssigned
      : data?.traderAssigned === 0;

    const statusClass =
      data.status === "TERMS_ACCEPTED"
        ? Styles.acceptedStatus
        : data.status === "ACTIVE"
          ? Styles.active
          : data.status === "WITHDRAWN"
            ? Styles.active
            : data.status === "TERMS_INITIATED"
              ? Styles.active
              : data.status === "TERMS_INITIATE_AND_ACCEPT"
                ? Styles.active
                : data.status === "RECEIVED"
                  ? Styles.active
                  : data.status === "HOLD"
                    ? Styles.hold
                    : data.status === "ONGOING" || data.status === "COMPLETED"
                      ? Styles.ongoing
                      : data.status === "ACCEPTED"
                        ? Styles.acceptedStatus
                        : data.status === "PLACED"
                          ? Styles.active
                          : "";

    const statusDotClass =
      data.status === "TERMS_ACCEPTED"
        ? Styles.acceptedDot
        : data.status === "ACTIVE"
          ? Styles.activeDot
          : data.status === "WITHDRAWN"
            ? Styles.activeDot
            : data.status === "TERMS_INITIATED"
              ? Styles.activeDot
              : data.status === "TERMS_INITIATE_AND_ACCEPT"
                ? Styles.activeDot
                : data.status === "HOLD"
                  ? Styles.holdDot
                  : data.status === "ONGOING" || data.status === "COMPLETED"
                    ? Styles.ongoingDot
                    : data.status === "ACCEPTED"
                      ? Styles.acceptedDot
                      : data.status === "PLACED"
                        ? Styles.activeDot
                        : data.status === "RECEIVED"
                          ? Styles.activeDot
                          : data.status === "ONGOING"
                            ? Styles.acceptedDot
                            : "";

    const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

    const Header = ({ data }) => {
      return (
        <>
          <PdfPreviewModal />
          <div className={`display_flex_row ${Styles.selfListingHeader}`}>
            <div className={Styles.selfListingHeaderLeft}>
              <div className={Styles.listingNumber}>
                {data?.name}{" "}
                <span className={`${Styles.status} ${statusClass}`}>
                  <span
                    className={`${Styles.statusDot} ${statusDotClass}`}
                  ></span>
                  {/* Override text for TERMS_ACCEPTED */}
                  {data.status === "TERMS_ACCEPTED"
                    ? "Accepted"
                    : data.status === "ONGOING"
                      ? "Ongoing"
                      : data.status === "RECEIVED"
                        ? "Active"
                        : data.status === "WITHDRAWN"
                          ? "Active"
                          : data.status === "PLACED"
                            ? "Active"
                            : data.status === "TERMS_INITIATED"
                              ? "Active"
                              : data.status === "TERMS_INITIATE_AND_ACCEPT"
                                ? "Active"
                                : data.status.toLowerCase().charAt(0) +
                                  data.status.toLowerCase().slice(1)}
                </span>
              </div>
              {data?.listingEntityName && (
                <div className={Styles.listingExpiry}>
                  <span className="pending">Entity Name:</span>
                  <span className={Styles.listingExpiryDetails}>
                    {data?.listingEntityName}
                  </span>
                </div>
              )}
              <div className={Styles.listingExpiry}>
                <span className="warning">Expires on</span>
                <span className={Styles.listingExpiryDetails}>
                  {formatDate(data?.listingExpDate)} -{" "}
                  {formatSlotTime(data?.listingExpTime)}
                </span>
              </div>
            </div>
            <div>
              {" "}
              <button
                title={`${
                  data.termsDocumentId
                    ? "View Terms & Conditions"
                    : "T&C not available"
                }`}
                onClick={() => {
                  handlePreviewGeneralTerms(data.termsDocumentId);
                }}
                style={{
                  cursor: data.termsDocumentId ? "pointer" : "not-allowed",
                  opacity: data.termsDocumentId ? 1 : 0.6,
                }}
                disabled={data.termsDocumentId ? false : true}
                className={Styles.tandContainer}
              >
                <span>General T&C</span>
                <CallMadeOutlinedIcon
                  style={{ fontSize: "10px", marginTop: "-10px" }}
                />
              </button>
              <button
                onClick={() => {
                  handlePreviewGeneralTerms(
                    "https://otc2-dev.s3.ap-south-1.amazonaws.com/assets/GNA+Energy+-+System+T%26C+-+Bilateral.pdf",
                    {
                      hideHeader: true,
                    },
                  );
                }}
                style={{
                  cursor: "pointer",
                  paddingRight: "0px",
                }}
                className={Styles.tandContainer}
              >
                <span>System T&C</span>
                <CallMadeOutlinedIcon
                  style={{ fontSize: "10px", marginTop: "-10px" }}
                />
              </button>
            </div>
          </div>
        </>
      );
    };

    const ActionButtons = ({ data }) => {
      const counterList = useSelector(
        (state) => state?.CapacitySlice?.counterList,
      );
      const hasIsApproved =
        data.id == activeId &&
        counterList?.some((item) => item.status === "APPROVED");
      const navigate = useNavigate();
      const hasApprovedAndPending = useSelector(
        (state) => state?.listingStatusSlice?.hasApprovedAndPending,
      );
      const [openDuplicateListingModal, setOpenDuplicateListingModal] =
        useState(false);
      const [openEditListingModal, setOpenEditListingModal] = useState(false);
      const [loading, setLoading] = useState(false);
      const [withdrawLoading, setWithdrawLoading] = useState(false);
      const [holdLoading, setHoldLoading] = useState(false);
      const [resumeLoading, setResumeLoading] = useState(false);
      const [downloadLoading, setDownloadLoading] = useState(false);

      const [chatList, setChatList] = useState([]);
      const dispatch = useDispatch();

      const handleNavigate = () => {
        // if (data?.status === "ACTIVE") {
        //   return;
        // }
        dispatch(setActiveListingId(data?.id));
        if (
          data?.status === "PLACED" ||
          data?.status === "RECEIVED" ||
          data?.status === "ACTIVE" ||
          data?.status === "HOLD"
        ) {
          navigate(`/ledger?id=${data?.id}`);
        } else if (
          data?.status === "TERMS_INITIATED" ||
          data?.status === "APPROVED" ||
          data?.status === "TERMS_ACCEPTED"
        ) {
          navigate(`/ledger?id=${data?.id}`, {
            state: { hasApprovedAndPending: hasApprovedAndPending },
          });
        } else {
          navigate(`/ledger?id=${data?.id}`);
        }

        localStorage.setItem("hideBilateralTabs", "false");
      };

      const handleDuplicateSubmit = async (data) => {
        setLoading(true);
        let res = await createListing(data, user);
        if (res?.data?.code === 200) {
          setOpenDuplicateListingModal(false);
          window.location.reload();
        }
        setLoading(false);
      };

      async function handleEditSubmit(params, oldData) {
        setLoading(true);
        const {
          listingExpDate,
          listingExpTime,
          termsExpDate,
          termsExpTime,
          bidEndAt,
          ...rest
        } = params;

        rest.name = data.name;
        rest.id = data.id;

        if (rest.termsDocumentId === null) {
          delete rest.termsDocumentId;
        }

        if (Array.isArray(rest.slots) && Array.isArray(oldData.slots)) {
          rest.slots = rest.slots.map((slot, idx) => {
            if (oldData.slots[idx] && oldData.slots[idx].id !== undefined) {
              return { ...slot, id: oldData.slots[idx].id };
            }
            return slot;
          });
        }

        function slotsChanged(newSlots, oldSlots) {
          if (
            !Array.isArray(newSlots) ||
            !Array.isArray(oldSlots) ||
            newSlots.length !== oldSlots.length
          ) {
            return true;
          }
          for (let i = 0; i < newSlots.length; i++) {
            const newSlot = newSlots[i];
            const oldSlot = oldSlots[i];
            const allKeys = new Set([
              ...Object.keys(newSlot),
              ...Object.keys(oldSlot),
            ]);
            for (const key of allKeys) {
              if (newSlot[key] !== oldSlot[key]) {
                return true;
              }
            }
          }
          return false;
        }

        const changedFields = {};
        for (const key in rest) {
          if (key === "slots") {
            if (slotsChanged(rest.slots, oldData.slots)) {
              changedFields.slots = rest.slots;
            }
          } else if (rest[key] !== oldData[key]) {
            changedFields[key] = rest[key];
          }
        }

        changedFields.id = data.id;
        let res = await editListing(rest, user);
        if (res?.data?.code === 200) {
          setOpenEditListingModal(false);
          window.location.reload();
        }
        setLoading(false);
      }

      async function handleWithdraw() {
        setWithdrawLoading(true);
        let res = await withdrawListing(data.id, user);
        if (res?.data?.code === 200) {
          setOpenEditListingModal(false);
          window.location.reload();
        }
        setWithdrawLoading(false);
      }

      async function handleHold() {
        setHoldLoading(true);
        let res = await holdListing(data.id, user);
        if (res?.data?.code === 200) {
          setOpenEditListingModal(false);
          window.location.reload();
        }
        setHoldLoading(false);
      }

      async function handleResume() {
        setResumeLoading(true);
        let res = await resumeListing(data.id, user);
        if (res?.data?.code === 200) {
          setOpenEditListingModal(false);
          window.location.reload();
        }
        setResumeLoading(false);
      }

      const handleChat = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        let res = await getCommonChatDetails({ name: data?.name });
        if (res?.data?.length > 0) {
          setChatList(res?.data);
        } else {
          ErrorMessage("The chat was not established for this listing.");
        }
      };

      const disableEdit =
        hasIsApproved ||
        data?.status === "TERMS_ACCEPTED" ||
        data?.status === "TERMS_INITIATED" ||
        data?.status === "CLOSED" ||
        data?.status === "SCHEDULED" ||
        data?.status === "ONGOING";
      async function handleDownload() {
        setDownloadLoading(true);
        try {
          const response = await downloadListing(data.id);
          const blob = response.data;
          const url = window.URL.createObjectURL(
            new Blob([blob], {
              type: "application/pdf",
            }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `listing_${data.name}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          toast.success("Listing downloaded successfully!");
        } catch (error) {
          toast.error(
            error?.response?.data?.message || "Failed to download listing.",
          );
        }
        setDownloadLoading(false);
      }

      return (
        <>
          <div
            style={{
              cursor: "pointer",
            }}
            className={`display_flex_row ${
              isActive
                ? Styles.button_container_active
                : Styles.button_container
            }`}
          >
            <div
              title={
                disableEdit ? "Cannot edit accepted or finalized listings" : ""
              }
              style={{
                cursor: disableEdit ? "not-allowed" : "pointer",
                opacity: disableEdit ? 0.5 : 1,
              }}
              onClick={() => {
                if (disableEdit) return;
                setOpenEditListingModal(true);
              }}
              className="display_flex_column_gap_4"
            >
              {isActive ? (
                <Edit className={Styles.button_icon} />
              ) : (
                <EditInactive className={Styles.button_icon} />
              )}
              <span>Edit</span>
            </div>
            <div
              className="display_flex_column_gap_4"
              style={{
                cursor: "pointer",
              }}
              onClick={() => handleNavigate()}
            >
              {isActive ? (
                <Request className={Styles.button_icon} />
              ) : (
                <RequestInactive className={Styles.button_icon} />
              )}
              <span>Ledger</span>
            </div>
            <div
              className="display_flex_column_gap_4"
              onClick={(e) => !(data?.status === "ACTIVE") && handleChat(e)}
              style={{
                cursor: data?.status === "ACTIVE" ? "not-allowed" : "pointer",
              }}
            >
              {isActive ? (
                <Chat className={Styles.button_icon} />
              ) : (
                <ChatInactive className={Styles.button_icon} />
              )}
              <span>Chat</span>
            </div>
            <div
              style={{
                cursor: downloadLoading ? "not-allowed" : "pointer",
                opacity: downloadLoading ? 0.6 : 1,
                position: "relative",
              }}
              onClick={() => !downloadLoading && handleDownload()}
              className="display_flex_column_gap_4"
            >
              {downloadLoading ? (
                // Simple loader, replace with your spinner if needed
                <span className={Styles.button_icon}>
                  <svg width="18" height="18" viewBox="0 0 50 50">
                    <circle
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke="white"
                      strokeWidth="4"
                      strokeDasharray="31.415, 31.415"
                      transform="rotate(72.9642 25 25)"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </svg>
                </span>
              ) : isActive ? (
                <Download className={Styles.button_icon} />
              ) : (
                <DownloadInactive className={Styles.button_icon} />
              )}
              <span>Download</span>
            </div>
            {/* Show which .env file is active (for debugging) */}
            {process.env.REACT_APP_ENV === "qa" && (
              <div
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpenDuplicateListingModal(true);
                }}
                className="display_flex_column_gap_4"
              >
                {isActive ? (
                  <Duplicate className={Styles.button_icon} />
                ) : (
                  <DuplicateInactive className={Styles.button_icon} />
                )}
                <span>Duplicate</span>
              </div>
            )}
          </div>

          {openDuplicateListingModal && (
            <ConGenListingModal
              data={data}
              type={"duplicate"}
              open={openDuplicateListingModal}
              loading={loading}
              handleClose={() => setOpenDuplicateListingModal(false)}
              handleSubmit={handleDuplicateSubmit}
            />
          )}
          {openEditListingModal && (
            <ConGenListingModal
              editId={data.id}
              data={data}
              open={openEditListingModal}
              loading={loading}
              withdrawLoading={withdrawLoading}
              holdLoading={holdLoading}
              resumeLoading={resumeLoading}
              handleClose={() => setOpenEditListingModal(false)}
              handleSubmit={handleEditSubmit}
              handleWithdraw={handleWithdraw}
              handleHold={handleHold}
              handleResume={handleResume}
            />
          )}
          {chatList?.length > 0 && (
            <CombinedChatModal
              open={chatList?.length > 0}
              handleClose={() => setChatList([])}
              data={chatList}
              selfName={data?.name}
            />
          )}
        </>
      );
    };

    const ContentData = ({ data, length, wholeData }) => {
      return (
        <>
          <div className={Styles.detailsMainCont}>
            <div className={Styles.commonElem}>
              <div className={Styles.eachElemCom}>
                <div>Quantity</div>
                <div className={Styles.eachElemComValue}>
                  {data?.purchaseEnergy || data?.sellEnergy}{" "}
                  <span
                    style={{
                      fontSize: "10px",
                      color: "var(--fourth-color-text)",
                    }}
                  >
                    (MW)
                  </span>
                </div>
              </div>
              <div className={Styles.eachElemCom}>
                <div>Energy Rate</div>
                <div className={Styles.eachElemComValue}>
                  {data?.energyRateStr ||
                    data?.landingCost ||
                    data?.sellingCost}{" "}
                  <span
                    style={{
                      fontSize: "10px",
                      color: "var(--fourth-color-text)",
                    }}
                  >
                    (₹/kWh)
                  </span>
                </div>
              </div>
              <div className={Styles.eachElemCom}>
                <div>Energy Type</div>
                <div className={Styles.eachElemComValue}>
                  {wholeData?.energyFuelType}
                </div>
              </div>
              <div className={Styles.eachElemCom}>
                <div>Delivery Type</div>
                <div className={Styles.eachElemComValue}>
                  {wholeData?.isInterstate ? "Interstate" : "Intra-state"}
                </div>
              </div>
            </div>
            <div className={Styles.detailsContP2}>
              <div className={Styles.eachelemP2}>
                <div>Product Type</div>
                <div className={Styles.eachElemComValue}>
                  {(() => {
                    const lt = wholeData?.listingType;
                    return lt === "INTRA_DAY"
                      ? "Intraday"
                      : lt === "NEXT_DAY"
                        ? "Next Day"
                        : lt === "UPTO_SEVEN_DAYS"
                          ? "Next 7 Days"
                          : lt === "GREATER_THAN_SEVEN_DAYS"
                            ? "Custom"
                            : // ? "Greater than 7 Days"
                              "-";
                  })()}
                </div>
              </div>
              <div className={Styles.eachelemP2}>
                <div>Start & End Date</div>
                <div className={Styles.eachElemComValue}>
                  {formatDate(data?.dateStartAt)} -{" "}
                  {formatDate(data?.dateEndAt)}
                </div>
              </div>
              <div className={Styles.eachelemP2}>
                <div>Start & End Time</div>
                <div className={Styles.eachElemComValue}>
                  {formatSlotTime(data?.slotStartAt)} -{" "}
                  {formatSlotTime(data?.slotEndAt)}
                </div>
              </div>
            </div>
            {length > 1 && (
              <div
                type="button"
                onClick={() => {
                  handleOpenIndent(data);
                }}
                className={Styles.viewMoreElem}
              >
                View All Requisitions
              </div>
            )}
          </div>
        </>
      );
    };

    return (
      <>
        <div
          type="button"
          onClick={() => {
            setActiveId(data?.id);
            dispatch(setActiveListingId(data?.id));
            dispatch(fetchLedgerBids(data?.id));
          }}
          className={`display_flex_column ${
            isActive
              ? Styles.selfListingContainer
              : Styles.selfListingContainerNoActive
          }`}
          ref={ref}
        >
          <Header data={data} />
          <ContentData
            wholeData={data}
            data={data?.slots?.[0]}
            length={data?.slots?.length}
          />
          {alterButton && viewButtons && (
            <ActionButtons isActive={isActive} data={data} />
          )}
        </div>
      </>
    );
  },
);

export default SelfListingBox;
